import { useState, useEffect } from 'react'
import dayjs from 'dayjs'

import Examination from './Examination'

const TimedExamination = ({examination, page, updatePage, updateProgress}) => {
  const [timerOn, setTimerOn] = useState(false)
  const [time, setTime] = useState(0)
  const [readableTime, setReadableTime] = useState('Calculating...')
  const [timeEnd, setTimeEnd] = useState(false)

  const startTimer = (timeEnd) => {
    setTime(timeEnd)
    setTimerOn(true)
  }

  const updateTime = () => {
    setTime(time - 1)

    const days = Math.floor(time / (60 * 60 * 24))
    const hours = Math.floor((time - (days * 60 * 60 * 24)) / (60 * 60))
    const minutes = Math.floor((time - (days * 60 * 60 * 24) - (hours * 60 * 60)) / 60)
    const seconds = Math.floor((time - (days * 60 * 60 * 24) - (hours * 60 * 60) - (minutes * 60)))

    const time_formatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

    setReadableTime(time_formatted)
  }

  const forceStopTime = () => {
    setTimeEnd(() => !timeEnd)
  }

  useEffect(() => {
    if (timerOn === false) return

    const interval = setInterval(() => {
      updateTime()
    }, 1000)

    if (time < 0 && timerOn === true) {
      forceStopTime()
      setTimerOn(false)
      clearInterval(interval)
      return;
    }

    return () => clearInterval(interval)
  })

  return (
    <>
      <Examination
        startTimer={startTimer}
        examination={examination}
        currentTime={readableTime}
        onTimeEnd={timeEnd}
        page={page}
        updatePage={updatePage}
        updateProgress={updateProgress}
      />
    </>
  )
}

export default TimedExamination